module.exports = __webpack_public_path__ + "img/IMG_6558_P_L_Black.f71110f8.jpg";